import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Popover } from '@usepepper/sprout-kit-ui';
import { Pressable, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface PricingReviewAction {
  icon: React.ReactNode;
  id: string;
  label: string;
  onSelect: () => void;
}

interface Props {
  actions: PricingReviewAction[];
  isOpen: boolean;
  onActionSelect: (action: PricingReviewAction) => void;
  onOpenChange: (open: boolean) => void;
  trigger: React.ReactNode;
}

export const PricingReviewActionsPopover: React.FC<Props> = ({
  actions,
  isOpen,
  onActionSelect,
  onOpenChange,
  trigger,
}) => {
  const [styles] = useStyles();

  return (
    <Popover
      allowFlip
      offset={4}
      onOpenChange={onOpenChange}
      open={isOpen}
      placement="bottom-end"
    >
      <Popover.Anchor>{trigger}</Popover.Anchor>
      <Popover.Content disableFocusScope>
        <View style={styles.actionsMenu}>
          <View style={styles.actionsContent}>
            {actions.map((action) => (
              <Pressable
                key={action.id}
                onPress={() => onActionSelect(action)}
                style={styles.actionRow}
              >
                <View style={styles.actionLeft}>
                  <View style={styles.actionLeadingVisual}>{action.icon}</View>
                  <Typography variant="paragraph-md">{action.label}</Typography>
                </View>
              </Pressable>
            ))}
          </View>
        </View>
      </Popover.Content>
    </Popover>
  );
};

const useStyles = createStyles((theme) => ({
  actionLeadingVisual: {
    alignItems: 'center',
    minWidth: 16,
  },
  actionLeft: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSmall,
  },
  actionRow: {
    alignItems: 'center',
    borderRadius: theme.sk.radii.radiusSmall,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: theme.sk.spacing.spaceSmall,
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  actionsContent: {
    width: '100%',
  },
  actionsMenu: {
    padding: theme.sk.spacing.spaceXsmall,
  },
}));
